import { jsx as _jsx } from "react/jsx-runtime";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useMemo } from "react";
import { TopicV2 } from "./TopicV2";
const TopicV2Sortable = (props)=>{
    const { topic , showPin , showUser  } = props;
    const { setNodeRef , listeners , attributes , transform , transition , isDragging ,  } = useSortable({
        id: String(topic.id)
    });
    const dragProvided = useMemo(()=>{
        return {
            listeners,
            attributes,
            style: {
                transform: CSS.Transform.toString(transform),
                transition,
                zIndex: isDragging ? 1 : undefined,
                cursor: isDragging ? "grab" : undefined
            }
        };
    }, [
        attributes,
        isDragging,
        listeners,
        transform,
        transition
    ]);
    return /*#__PURE__*/ _jsx(TopicV2, {
        ref: setNodeRef,
        topic: topic,
        dragProvided: dragProvided,
        isDragging: isDragging,
        showPin: showPin,
        showUser: showUser
    });
};
export default TopicV2Sortable;
